import { useGraphqlQuery } from "@harea/component"
import { TDepartment } from "@harea/component"
import { DepartmentListQuery } from "../queries/DepartmentListQuery"

export const useDepartmentListQuery = (suspense?: boolean) => {
    return useGraphqlQuery<DepartmentListQuery, Array<TDepartment>>(new DepartmentListQuery(), { suspense })
}